<template>
  <div>
    <div class="modal-content-container" v-if="!isLoading">
      <e-steps :current="currentStep" v-if="availableModeration" @changeStep="onChangeStep">
        <e-step label="Lock Tokens & Accept the rules">
          <e-lock-tokens v-model="lockedModel"/>
        </e-step>
        <e-step v-for="moderationNumber in numberOfModeration" :label="`Moderation # ${moderationNumber}`" :key="moderationNumber">
         
          <e-moderation-view v-if="moderationGroup" :moderationId="moderationGroup.moderation[moderationNumber - 1]" ref="moderation" @changeState="onChangeState" @changeEval="onChangeEval"></e-moderation-view>
        </e-step>
      </e-steps>
      <div v-else>
        <div class="not-available-message" style="position: relative; margin: 0; padding-top: 0;">
          <h3>No rates available now.</h3>                
          <div class="img-container" style="margin: 20px auto;">
            <svg version="1.1" style="fill: #0672f3;" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 465.2 465.2" xml:space="preserve">
              <g>
                <g id="Layer_2_16_">
                  <g>
                    <path d="M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804
                      c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008
                      c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"/>
                    <path d="M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475
                      c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423
                      c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"/>
                    <path d="M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546
                      c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452
                      c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"/>
                    <path d="M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422
                      c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401
                      c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"/>
                    <path d="M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298
                      c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171
                      c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"/>
                    <path d="M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253
                      c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812
                      c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"/>
                    <path d="M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287
                      c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628
                      C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468
                      c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682
                      c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161
                      C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021
                      c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978
                      c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896
                      C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129
                      c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16
                      c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898
                      c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103
                      C214.925,437.943,208.163,428.223,197.999,426.402z"/>
                    <path d="M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69
                      c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329
                      C236.243,89.978,229.477,83.198,221.124,83.198z"/>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>There are currently no rates available, try again later.</p>
        </div>
      </div>
      <transition name="fade">
        <div v-if="isFinished" class="success-message">
          <div class="img-container">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path style="fill:#0672f3;" d="M496.396,61.776c20.807,20.807,20.807,54.664,0,75.471L248.82,384.822
                c-6.895,6.895-15.951,10.342-25.007,10.342c-9.056,0-18.112-3.447-25.007-10.342l-120.34-120.34
                c-20.807-20.807-20.807-54.664,0-75.471s54.664-20.807,75.471,0l69.876,69.862L420.925,61.776
                c10.41-10.397,24.063-15.609,37.742-15.609C472.319,46.167,485.999,51.379,496.396,61.776z M477.052,117.904
                c10.137-10.15,10.137-26.648,0-36.785c-10.137-10.137-26.648-10.137-36.785,0L241.16,280.227
                c-4.637,4.637-10.793,7.182-17.346,7.182c-6.553,0-12.708-2.544-17.332-7.182l-71.887-71.873
                c-5.075-5.075-11.724-7.606-18.386-7.606c-6.662,0-13.324,2.531-18.399,7.606c-10.137,10.137-10.137,26.634,0,36.785l120.34,120.34
                c3.119,3.119,8.208,3.119,11.327,0L477.052,117.904z"/>
              <path style="fill:#D2E3FB;" d="M477.052,81.119c10.137,10.137,10.137,26.634,0,36.785L229.477,365.479
                c-3.119,3.119-8.208,3.119-11.327,0L97.81,245.139c-10.137-10.15-10.137-26.648,0-36.785c5.075-5.075,11.737-7.606,18.399-7.606
                c6.662,0,13.31,2.531,18.386,7.606l71.887,71.873c4.624,4.637,10.78,7.182,17.332,7.182s12.708-2.544,17.346-7.182L440.268,81.119
                C450.404,70.982,466.916,70.982,477.052,81.119z"/>
              <path style="fill:#0672f3;" d="M449.72,239.845c0.383,5.308,0.575,10.739,0.575,16.156c0,124.143-100.997,225.141-225.141,225.141
                S0,380.144,0,256S101.011,30.86,225.154,30.86c49.165,0,95.867,15.568,135.046,45.006c6.046,4.542,7.264,13.119,2.722,19.152
                c-4.542,6.046-13.119,7.264-19.152,2.722c-34.418-25.855-75.43-39.521-118.617-39.521C116.086,58.219,27.359,146.946,27.359,256
                s88.727,197.781,197.795,197.781c109.055,0,197.781-88.727,197.781-197.781c0-4.761-0.178-9.535-0.506-14.186
                c-0.547-7.538,5.13-14.09,12.654-14.637C442.634,226.644,449.173,232.307,449.72,239.845z"/>
            </svg>
          </div>
          <h3>Your moderation has been saved.</h3>
          <p>Soon your moderation will be taken into account in the overall assessment of "{{ asset.name }}"" asset.</p>
        </div>
      </transition>
    </div>
    <div class="modal-footer">
      <e-button type="outlined" v-if="!isFinished" @click="() => this.$emit('closeModal')">Cancel</e-button>
      <div class="d-flex ml-auto" v-if="availableModeration || isFinished">
        <e-button v-if="!isFinished && currentStep !== 1" @click="onPreviewClick" style="margin-right: 30px">Preview</e-button>
        <e-button v-if="!isFinished" :disabled="nextButtonDisabled" @click="onNextClick">{{ nextButtonText }}</e-button>
        <e-button v-if="isFinished" @click="() => this.$emit('closeModal')">Ok</e-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex';
  import EModerationView from "../../elements/moderationView/view";
  import Services from "../../../services";
  import _ from 'lodash';

	export default {
		name: "em-moderate-steps",
    components: {EModerationView},
    props: {
      asset: {
        type: Object,
        default: null,
      },
    },
	    data() {
		  return {
        localLockedModel: {
          locked: 0,
          rules: false,
          disabled: false,
        },
		    numberOfModeration: 0,
		    moderationGroup: null,
        currentStep: 1,
        nextButtonDisabled: false,
        nextButtonText: 'Next',
        isLoading: true,
        availableModeration: false,
        isFinished: false
      }
    },
    watch: {
      asset: {
        handler(asset) {
        console.log('handlers',asset)
          if(asset) {
            this.onChangeAsset(asset);
          }
        },
        immediate: true,
      }
    },
	    methods: {
      ...mapActions('moderation', {
        fetchModerationGroup: 'fetchModerationGroupByAsset',
        fetchModerationGroupsByFilter: 'fetchModerationGroupsByFilter',
        loadNewModeration: 'loadNewModeration'
      }),
      getNumberOfModeration(asset, moderationGroup = null) {
        const assetModerators = Number(asset && asset.totalModeration);
        const normalizedAssetModerators = Number.isFinite(assetModerators)
          ? Math.max(0, Math.floor(assetModerators))
          : 0;
        const currentModerationCount = Array.isArray(moderationGroup && moderationGroup.moderation)
          ? moderationGroup.moderation.length
          : 0;

        return Math.max(normalizedAssetModerators, currentModerationCount);
      },
      buildModerationPayload(extra = {}) {
        const userId = this.user && this.user.id ? this.user.id : undefined;
        const assetId = this.asset ? this.asset.id : undefined;
        const groupId = this.moderationGroup ? this.moderationGroup.id : undefined;

        return {
          user_id: userId,
          asset_id: assetId,
          locked_tokens: this.lockedModel.locked,
          moderation_group_id: groupId,
          moderation: Array.isArray(this.moderationGroup && this.moderationGroup.moderation)
            ? this.moderationGroup.moderation.map(item => ({
                id: item && item.id ? item.id : item,
                moderation_group_id: groupId,
                status: 'draft',
              }))
            : [],
          ...extra,
        };
      },
      getModerationGroupStatus(moderationGroup) {
        if(!moderationGroup) {
          return null;
        }

        if(moderationGroup.status !== undefined && moderationGroup.status !== null) {
          return moderationGroup.status;
        }

        if(moderationGroup.state !== undefined && moderationGroup.state !== null) {
          return moderationGroup.state;
        }

        return null;
      },
      applyModerationGroupState(asset, moderationGroup) {
        const hasModerationGroup =
          moderationGroup &&
          typeof moderationGroup === 'object' &&
          Array.isArray(moderationGroup.moderation);
        const groupStatus = this.getModerationGroupStatus(moderationGroup);

        this.asset = asset;
        this.moderationGroup = hasModerationGroup ? moderationGroup : null;
        this.numberOfModeration = this.getNumberOfModeration(asset, this.moderationGroup);

        if (hasModerationGroup && groupStatus === 'published') {
          this.availableModeration = false;
          this.isFinished = true;
          this.currentStep = 1;
          this.nextButtonText = 'Next';
          this.nextButtonDisabled = false;
          return;
        }

        this.isFinished = false;
        this.availableModeration = hasModerationGroup ? true : this.availableModeration;
        this.currentStep = hasModerationGroup ? moderationGroup.moderation.length + 1 : 1;
      },
      async onChangeAsset(asset) {
        try {
          console.log('ooo onChangeAsset',asset)
          this.isLoading = true;
          this.isFinished = false;

          let moderationGroup = await Services.Moderation.fetchCurrentModerationGroup(asset.id);
          console.log('moderationGroup',moderationGroup)
          const hasModerationGroup =
            moderationGroup &&
            typeof moderationGroup === 'object' &&
            Array.isArray(moderationGroup.moderation);

          if(!hasModerationGroup) {
            moderationGroup = null;
            this.availableModeration = await Services.Moderation.moderationIsAvailable(asset.id);
          }

          this.applyModerationGroupState(asset, moderationGroup);
          this.isLoading = false;
	      } catch(ex) {
	        console.log('ex',ex)
          this.isLoading = false;
	      }
      },
      onChangeEval(rate) {
        this.nextButtonDisabled = !(rate > 0);
      },
      async onNextClick() {
                console.log('nextnext',this.currentStep )

        if(this.currentStep === 1) {

          if(!this.moderationGroup) {
            this.isLoading = true;
            try {
              let computedModerationGroup = await Services.Moderation.createModeration(
                this.buildModerationPayload({
                  status: 'draft',
                })
              );

              computedModerationGroup.moderation = _.map(computedModerationGroup.moderation, m => m.id)
              this.applyModerationGroupState(this.asset, computedModerationGroup);
            } catch (error) {
              const currentModerationGroup = await Services.Moderation.fetchCurrentModerationGroup(this.asset.id);
              this.applyModerationGroupState(this.asset, currentModerationGroup);
            } finally {
              this.isLoading = false;
            }
          }

          if(this.isFinished) return;
          this.currentStep += 1;
        } else {
          const viewComponent = this.$refs.moderation[this.currentStep - 2];
          switch (viewComponent.state) {
            case 'moderating':
            case 'complete':
              if(viewComponent.eval > 0) {
                viewComponent.state = 'complete';

                // Если это крайняя модерация то загружаем с сервера новую
                if(this.currentStep - 1 === this.moderationGroup.moderation.length) {
                  let moderation = await Services.Moderation.fetchNextModeration({
                    ...this.buildModerationPayload({
                      moderation_id: viewComponent.moderationId,
                      rating_id: viewComponent.moderation && viewComponent.moderation.rate,
                      evaluate: viewComponent.eval,
                      status: 'published',
                    }),
                  });

                  if(moderation.currentState === 'published') {
                    this.isFinished = true;
                    return;
                  }

                  if (moderation.next) {
                    this.moderationGroup.moderation.push(moderation.next.id);
                    this.currentStep += 1;
                  }
                } else {
                  // иначе сохраняем изменения

                  this.currentStep += 1;
                }
              }
              break;
            case 'ready':
              viewComponent.state = 'moderating';
              break;
            case 'view':
              // nothing or if exist criteria - next
              break;
          }
        }
      },
      onPreviewClick() {
        if(this.currentStep > 1) {
          const viewComponent = this.$refs.moderation[this.currentStep - 2];
          switch (viewComponent.state) {
            case 'moderating':
              if(viewComponent.eval > 0) {
                viewComponent.state = 'complete';
              } else {
                viewComponent.state = 'ready';
              }
              break;
            default: {
              this.currentStep -= 1;
            }
          }
        }
      },
      onChangeStep(step) {
        console.log('onChangeStep',step)
        if(step === 1) {
          this.nextButtonText = 'Next';
          // this.nextButtonDisabled = !(this.lockedModel.rules && this.lockedModel.locked > 0);
          return;
        }

        if(step > 1) {
          this.$nextTick(() => {
            console.log('ss000',this.$refs, this.$refs.moderation)
            const moderationRefs = this.$refs.moderation;
            const viewComponent = Array.isArray(moderationRefs) ? moderationRefs[0] : null;
            console.log('ss0100', viewComponent)

            if(!viewComponent) return;
            
            switch (viewComponent.state) {
              case 'moderating':
                this.nextButtonText = 'Send';
                this.nextButtonDisabled = !viewComponent.allCriteriaShowed();
                break;
              case 'ready':
                if(step === this.numberOfModeration + 1) {
                  this.nextButtonText = 'Complete!';
                  this.nextButtonDisabled = false;
                } else {
                  this.nextButtonText = 'Next';
                  this.nextButtonDisabled = false;
                }
                break;
              case 'view':
                this.nextButtonText = 'Moderate Now';
                this.nextButtonDisabled = !viewComponent.allCriteriaShowed();
                break;
            }
          });
        }
      },
      onChangeState(state) {
        const viewComponent = this.$refs.moderation[this.currentStep - 2];
        switch (state) {
          case 'moderating':
            this.nextButtonText = 'Send';
            this.nextButtonDisabled = true;
            break;
          case 'ready':
            this.nextButtonText = 'Moderate Now';
            this.nextButtonDisabled = false;
            break;
          case 'view':
            this.nextButtonText = 'Moderate Now';
            this.nextButtonDisabled = true;
            break;
          case 'complete':
            this.nextButtonText = 'Next';
            this.nextButtonDisabled = false;
            break;
        }
        // this.nextButtonDisabled = !viewComponent.allCriteriaShowed();
      }
    },
    computed: {
      ...mapState('auth', {
        user: state => state.user,
      }),
      ...mapGetters('moderation', {
        getModerationGroup: 'moderationGroupByAsset'
      }),
      lockedModel: {
        get() {
          if(this.moderationGroup) {
            return {
              locked: this.moderationGroup.lockedTokens,
              rules: true,
              disabled: true,
            };
          }

          return this.localLockedModel;
        },
        set(value) {
          this.localLockedModel = {...value, disabled: false}
        }
      }
    },
    created() {
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/moderate/steps.vue